exports = module.exports = require("../app/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{height:44px;min-width:44px;padding:0 10px;border:none;background:hsla(0,0%,100%,.25);color:#ddd;cursor:pointer;position:relative;line-height:44px;text-align:center;font-size:20px;border-radius:2px;margin:0;outline:none;-webkit-transition:all .3s ease-in;transition:all .3s ease-in;display:inline-block;vertical-align:top}.btn:hover{background:hsla(0,0%,100%,.15)}.btn_blue{background:#46a7fe;color:#fff}.btn_blue:hover{background:#3c9df4}.btn_white{background:#fff;color:#46a7fe}.btn_ghost:hover,.btn_white:hover{opacity:.8}.btn_ghost,.btn_ghost:hover,.btn_trans,.btn_trans:hover{background:transparent}.btn_ghost,.btn_ghost:hover{border:2px solid #fff;line-height:40px;color:#fff}.btn_icon{padding:0}.btn_icon i{width:44px;height:44px;vertical-align:top;pointer-events:none}.btn_icon i svg{vertical-align:middle}.btn_disabled{opacity:.5;cursor:default}.btn input[type=file]{opacity:0;position:absolute;left:0;top:0;cursor:pointer;width:100%;height:44px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!../components/buttons.css
// module id = 227
// module chunks = 0